import { readFromLocalStorage } from '@jouzen/ecom-utils';
import { env } from 'next-runtime-env';

import { metricError, metricIncrement } from './reportMetrics';

export interface DebugAnalyticsOptions {
  data: { [key: string]: any };
  exception: boolean; // log to datadog as "exception" (rather than "error")
  level: 'log' | 'warn' | 'error'; // console level
  logToDatadog: string | undefined | null; // id to use for datadog logs
}

const DEFAULT_OPTIONS: DebugAnalyticsOptions = {
  data: {},
  exception: false,
  level: 'log',
  logToDatadog: null,
};

export function debugAnalytics(
  message: string,
  options: Partial<DebugAnalyticsOptions> = {},
) {
  const {
    data,
    exception: isException,
    level,
    logToDatadog: logId,
  } = { ...DEFAULT_OPTIONS, ...options };

  const isDebugging =
    env('NEXT_PUBLIC_DEBUG_ANALYTICS') === 'true' ||
    readFromLocalStorage('eop-debug-analytics');

  if (isDebugging && level && console[level]) {
    console[level](`[A] ${message}`, data);
  }

  if (!isDebugging && Boolean(logId)) {
    // Route to a severity-specific metric so informational and warning logs
    // don't inflate `web_eop_analytics.error` (which drives the error alert).
    // Only `error` level and exceptions are reported as errors; everything
    // else lands on `.warn` / `.info` and stays out of the error monitor.
    const payload = {
      ...data,
      id: logId,
      message,
      bucket: 'eop-analytics',
    };

    if (isException || level === 'error') {
      metricError('analytics', {
        ...payload,
        category: isException ? 'exception' : 'error',
      });
    } else if (level === 'warn') {
      metricIncrement('analytics.warn', { ...payload, category: 'warn' });
    } else {
      metricIncrement('analytics.info', { ...payload, category: 'info' });
    }
  }
}
